import styled from '@emotion/styled'

import { metrics } from 'component-library/__styling/settings'

import { supports } from 'component-library/__helpers/at-supports-helper'
import { colors } from 'component-library/__styling/settings/colors'
import { calcRem, breakpointMax, breakpoint } from 'component-library/__styling/style-functions'
import { useSelector } from 'react-redux'
import { AppState } from 'common/store'

export interface Props {
    isAmpRendered?: boolean
}

export const StyledBaseGrid = styled('div')<Props>(
    {
        margin: '0 auto',
        width: '100%',
        display: 'table', // Grid FallBack
        tableLayout: 'fixed', // Required for IE so content does not overflow

        // If grid is supported use css grid
    },
    supports('display: grid', {
        display: 'grid', // Override display: table
        gridTemplateColumns: '100%',

        // reset
        tableLayout: 'unset',
    }),
    props => ({
        maxWidth: props.isAmpRendered === true ? metrics.thewest.ampContentWidth : undefined,
        [breakpoint('sm')]: {
            position: 'relative',
            overflow: 'visible',
            height: 'auto',
        },
    })
)

export const StyledAmpContentContainer = styled('div')({
    width: '100%',
    padding: calcRem(metrics.thewest.margins.outerMargin),
    backgroundColor: colors.thewest.greyMouse,
})

export const StyledAmpContent = styled('div')({
    padding: calcRem(metrics.thewest.margins.md),
    backgroundColor: colors.white,
})

interface StyledCellProps {
    hasBackground?: boolean
}

export const StyledCell = styled('div')<StyledCellProps>(({ hasBackground }) => {
    return {
        display: 'block',
        backgroundColor: hasBackground ? colors.thewest.greyMouse : undefined,
    }
})

export const StyledFooterCell = styled(StyledCell)(() => {
    const { onAir } = useSelector((state: AppState) => state.theWestLive)
    // DPT-1778 offset for west live based on scheduling
    const radioOffset = onAir ? 69 : undefined
    const stickyFooterAdUnitHeight = 60

    return {
        paddingBottom: radioOffset && calcRem(radioOffset),
        // DPT-856: Spacing for sticky footer ad-unit
        [breakpointMax('sm')]: {
            paddingBottom: radioOffset
                ? calcRem(radioOffset + stickyFooterAdUnitHeight)
                : calcRem(stickyFooterAdUnitHeight),
        },
    }
})

export const StyledNestedGrid = styled('div')(
    {
        margin: '0 auto',
        width: '100%',

        display: 'table', // Grid FallBack
        tableLayout: 'fixed', // Required for IE so content does not overflow

        // If grid is supported use css grid
    },
    supports('display: grid', {
        display: 'grid', // Override display: table
        gridTemplateColumns: '100%',

        // reset
        tableLayout: 'unset',
    })
)

export const StyledNestedCell = styled('div')({
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    maxWidth: metrics.thewest.mainContentWidth,
    padding: `0 ${metrics.thewest.margins.outerMargin}px`,
    margin: '0 auto',
})
